<template>
  <div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 search-box-session loading-data" v-if="loading">
      <div class="loading">
        <p class="loading-bro">
          <svg id="load" x="0px" y="0px" viewBox="0 0 150 150"><circle id="loading-inner" cx="75" cy="75" r="60"></circle></svg>
        </p>
        <p class="text">در حال بارگذاری</p>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 table-box" :class="{'blure': loading}">
      <b-table :fields="fields" :items="items" @sort-changed="sortChange" responsive="md">
        <template v-slot:head(checkbox)="data">
          <b-form-checkbox size="lg" v-model="isSelectedAll" @change="selectAll(data)" />
        </template>
        <template v-slot:cell(checkbox)="data">
          <b-form-checkbox size="lg" :checked="isSelectedAll" v-model="data.item.selected" @change="select(data.item)" />
        </template>
        <template #cell(stock)="data">
          <b-badge class="mr-1" v-if="data.item.availableInStock" variant="primary">موجودی: {{ data.item.stockInventory }}</b-badge>
          <b-badge class="mr-1" v-if="data.item.availableInStock == false" variant="danger">ناموجود</b-badge>
        </template>
        <template #cell(createdBy)="row">
          <p>{{ row.value }}</p>
          <span class="text-muted subtext" v-b-tooltip.hover :title="$moment(row.item.createdOn).locale('fa').format('HH:mm - YYYY/MM/DD')">{{
            $moment(row.item.createdOn).locale("fa").fromNow()
          }}</span>
        </template>
        <template #cell(active)="row">
          <div dir="ltr">
            <toggle v-model="row.item.active" key="row.item.id" @input="statusChanged(row)" />
          </div>
        </template>
        <template #cell(groups)="row">
          <span v-b-tooltip.hover :title="row.value.join('، ')">{{ row.value.slice(0, 2).join("، ") }}</span>
        </template>
        <template #cell(actions)="data" class="operation-box">
          <span><a :href="`/p/${data.item.id}`" class="opretion-type session">مشاهده</a></span>
          <button class="icon-box">
            <span class="icon-operation icon-round-close f-s-13 has-tooltip" data-original-title="null"> </span
            ><span><a href="/panel/product/edit/408715" class="icon-operation icon-edit f-s-13 has-tooltip" data-original-title="null"></a></span>
          </button>
        </template>
      </b-table>
    </div>
    <b-row>
      <b-col sm="5" md="3" class="my-1">
        <b-form-group label="تعداد در صفحه" label-for="per-page-select" label-cols-sm="6" label-cols-md="4" label-cols-lg="5" label-align-sm="right" label-size="sm" class="mb-0">
          <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="9" class="pagination-box">
        <b-pagination class="float-left" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="left" size="md" first-number pills ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import Toggle from "./Toggle.vue"

export default {
  name: "ListTable",
  components: {
    Toggle
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          console.log(row, isSelected, selectedRowKeys)
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          console.log(isSelected, selectedRowKeys)
        }
      },
      isChecked: false,
      sortOption: {
        sortChange: params => {
          console.log("sortChange::", params)
          this.sortChange(params)
        }
      },
      perPage: 15,
      pageOptions: [15, 30, 60, 100],
      currentPage: 1,
      isSelectedAll: false,
      accepted: false
    }
  },
  watch: {
    currentPage(value) {
      this.setPage(value)
      this.reload()
    },
    perPage(value) {
      this.setPerPage(value)
      this.reload()
    }
  },
  computed: {
    ...mapGetters({
      fields: "products/getFields",
      items: "products/getList",
      totalRows: "products/getTotal",
      filters: "products/getFilters"
    })
  },
  methods: {
    ...mapMutations({
      setPage: "products/setPageIndex",
      setPerPage: "products/setPageSize",
      setOrder: "products/setOrder"
    }),
    init() {
      this.perPage = this.filters.pageSize
      this.currentPage = this.filters.pageIndex
    },
    sortChange(sort) {
      this.setOrder({
        by: sort.sortBy,
        type: sort.sortDesc ? "desc" : "asc"
      })
    },
    reload() {
      this.$emit("reload")
    },
    statusChanged(row) {
      var me = this
      this.$store
        .dispatch("products/setProductStatus", { productId: row.item.id, status: row.item.active })
        .then(data => {
          if (data.status == 200 && data.data.status) {
            console.log(row)
            if (data.data.result) {
              me.$toast.success("محصول فعال گردید.", "", { displayMode: 2 })
            } else {
              me.$toast.success("محصول غیرفعال گردید.", "", { displayMode: 2 })
            }
          }
          console.log(data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectAll(data) {
      console.log(data);
    },
    select(data) {

    }
  },
  beforeMount() {
    this.init()
    // const lang = {
    //   pagination: {
    //     goto: "برو",
    //     itemsPerPage: " ردیف",
    //     total: function (_total) {
    //       return "تعداد ردیف ها " + _total
    //     }
    //   },
    //   placeholder: "select p"
    // }
    // this.$veLocale.use(lang)
  }
}
</script>

<style scoped></style>
